export const DELETED_COMMENT = 'Komentārs dzēsts.'

export const ALL_POPULATION_GROUPS = 'Visi'
